import { render, staticRenderFns } from "./EbookPage.vue?vue&type=template&id=4c3b9490"
import script from "./EbookPage.vue?vue&type=script&lang=js"
export * from "./EbookPage.vue?vue&type=script&lang=js"
import style0 from "./EbookPage.vue?vue&type=style&index=0&id=4c3b9490&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports